export default __webpack_public_path__ + "static/media/element_90.4ec3a887.webp";